import { WithAccountId } from '@mews-commander/types';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { ProcessPaymentType } from '../ProcessPaymentType';
import { DISABLED_PROCESS_PAYMENT_TYPES } from '../const';
import { useGetChargeGuestOptionsSuspense } from './useGetChargeGuestOptionsSuspense';
import { useGetRecordPaymentOptionsSuspense } from './useGetRecordPaymentOptionsSuspense';
import { useGetPaymentTypesEnabledSettingSuspense } from './useGetPaymentTypesEnabledSettingSuspense';

export const useGetDefaultPaymentMethodTypeSuspense = ({
    accountId,
    allowedPaymentTypes,
}: { allowedPaymentTypes: ProcessPaymentType[] } & WithAccountId) => {
    const chargeGuestOptions = useGetChargeGuestOptionsSuspense({ accountId, allowedPaymentTypes });
    const recordPaymentOptions = useGetRecordPaymentOptionsSuspense({ accountId, allowedPaymentTypes });
    const paymentTypesEnabledSetting = useGetPaymentTypesEnabledSettingSuspense({ accountId });
    const isPciProxyMaintenanceDisabledPaymentsEnabled = useFeatureFlag(
        FeatureFlag.pciProxyMaintenanceDisabledPaymentsEnabled
    );
    const chargeGuestOptionsFiltered = chargeGuestOptions.filter(
        (option) =>
            !(isPciProxyMaintenanceDisabledPaymentsEnabled && DISABLED_PROCESS_PAYMENT_TYPES.includes(option.value))
    );

    const firstEnabledType =
        chargeGuestOptionsFiltered.length > 0
            ? chargeGuestOptionsFiltered.find((option) => paymentTypesEnabledSetting[option.value])?.value
            : recordPaymentOptions.find((option) => paymentTypesEnabledSetting[option.value])?.value;

    return chargeGuestOptions.length > 0
        ? firstEnabledType ?? chargeGuestOptions[0]?.value ?? null
        : firstEnabledType ?? recordPaymentOptions[0]?.value ?? null;
};
